import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/stores/auth';
import { CryptoProvider } from './lib/stores/crypto';
import { IkigaiProvider } from './lib/stores/ikigai';
import { ValuesProvider } from './lib/stores/values';
import { LifeAreasProvider } from './lib/stores/lifeareas';
import { VisionProvider } from './lib/stores/vision';
import { GoalsProvider } from './lib/stores/goals';
import { DecisionsProvider } from './lib/stores/decisions';
import Layout from './components/Layout';
import Holding from './pages/Holding';
// Landing is temporarily unrouted while the marketing page is rebuilt.
// import Landing from './pages/Landing';
import Auth from './pages/Auth';
import VerifyEmail from './pages/VerifyEmail';
import Unlock from './pages/Unlock';
import Home from './pages/Home';
import Foundation from './pages/Foundation';
import Goals from './pages/Goals';
import GoalDetail from './pages/GoalDetail';
import Ikigai from './pages/Ikigai';
import Values from './pages/Values';
import LifeWheel from './pages/LifeWheel';
import Vision from './pages/Vision';
import Decisions from './pages/Decisions';
import DecisionDetail from './pages/DecisionDetail';

function App() {
  // Log environment info in development mode
  useEffect(() => {
    if (import.meta.env.DEV) {
      console.log('Environment:', import.meta.env.VITE_ENVIRONMENT);
      console.log('API URL:', import.meta.env.VITE_API_URL);
    }
  }, []);

  return (
    <AuthProvider>
      <CryptoProvider>
        <IkigaiProvider>
          <ValuesProvider>
            <LifeAreasProvider>
              <VisionProvider>
                <GoalsProvider>
                  <DecisionsProvider>
                    <BrowserRouter>
                      <Routes>
                        <Route path="/" element={<Holding />} />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/unlock" element={<Unlock />} />
                        <Route path="/home" element={<Layout><Home /></Layout>} />
                        <Route path="/purpose/foundation" element={<Layout><Foundation /></Layout>} />
                        <Route path="/purpose/ikigai" element={<Layout><Ikigai /></Layout>} />
                        <Route path="/purpose/values" element={<Layout><Values /></Layout>} />
                        <Route path="/purpose/wheel" element={<Layout><LifeWheel /></Layout>} />
                        <Route path="/purpose/vision" element={<Layout><Vision /></Layout>} />
                        <Route path="/purpose/goals" element={<Layout><Goals /></Layout>} />
                        <Route path="/purpose/goals/:goalId" element={<Layout><GoalDetail /></Layout>} />
                        <Route path="/tools/decisions" element={<Layout><Decisions /></Layout>} />
                        <Route path="/tools/decisions/:decisionId" element={<Layout><DecisionDetail /></Layout>} />
                      </Routes>
                    </BrowserRouter>
                  </DecisionsProvider>
                </GoalsProvider>
              </VisionProvider>
            </LifeAreasProvider>
          </ValuesProvider>
        </IkigaiProvider>
      </CryptoProvider>
    </AuthProvider>
  );
}

export default App;
